// extracted by mini-css-extract-plugin
module.exports = {"container":"AttractionDetail_container__27qBS","header":"AttractionDetail_header__45udU","description":"AttractionDetail_description__1W3q4"};